import { useEffect, useState } from "react";

import { SelectFlowAndVersion } from "src/SelectFlowPane/SelectFlowPane";
import { Flow, FlowVersion } from "src/api/flowTypes";
import { Button } from "src/base-components/Button";
import { Modal } from "src/design-system/Modal";

type FlowToolFlowSelectionModalProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (flow: Flow, version: FlowVersion) => void;
};

export const FlowToolFlowSelectionModal: React.FC<
  FlowToolFlowSelectionModalProps
> = ({ open, onClose, onSelect }) => {
  const [selectedFlow, setSelectedFlow] = useState<Flow | null>(null);
  const [selectedVersion, setSelectedVersion] = useState<FlowVersion | null>(
    null,
  );

  // Reset the modal state upon reopening
  useEffect(() => {
    if (open) {
      setSelectedFlow(null);
      setSelectedVersion(null);
    }
  }, [open]);

  const handleSubmit = () => {
    if (selectedFlow && selectedVersion) {
      onSelect(selectedFlow, selectedVersion);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Select a Decision Flow</Modal.Header>
      <Modal.Content>
        <div className="flex h-[540px] flex-col">
          <SelectFlowAndVersion
            selectedFlow={selectedFlow}
            selectedVersionId={selectedVersion?.id}
            onFlowSelect={setSelectedFlow}
            onVersionSelect={setSelectedVersion}
          />
        </div>
      </Modal.Content>
      <Modal.Footer
        primaryButton={
          <Button
            dataLoc="flow-tool-selection-submit"
            disabled={selectedFlow === null || selectedVersion === null}
            onClick={handleSubmit}
          >
            Select version
          </Button>
        }
      />
    </Modal>
  );
};
